import type { ConfigurationData } from "~/app/store/bffApi";

const DEFAULT_RELATED_PRODUCTS_DESKTOP = 4;
const DEFAULT_RELATED_PRODUCTS_MOBILE = 3;

export function getRelatedProductsLimit(configuration: ConfigurationData | null, isDesktop: boolean): number {
  return isDesktop
    ? configuration?.addedToCartRelatedProductsDesktop ?? DEFAULT_RELATED_PRODUCTS_DESKTOP
    : configuration?.addedToCartRelatedProductsMobile ?? DEFAULT_RELATED_PRODUCTS_MOBILE;
}
